import React from 'react'
import Navbar from './Navbar'
import Sidebar from './FixedSidebar'
import Background from '../assets/images/background.png'

const Layout = ({ children }) => {
    return (
        <>
            <div className='flex flex-auto h-screen'>
                <div className='grow' style={{'backgroundImage': `url(${Background})`, overflowY: 'scroll', backgroundSize: 'cover'}}>
                    <Navbar />
                    <div className='m-5 flex flex-col items-center'>{children}</div>
                </div>
                <Sidebar />
            </div>
        </>
    )
}

export default Layout
